import {useExtensionStore} from "@project/app-state";
import {Avatar, Button, Tooltip} from "@project/design-system-web";
import {useI18n} from "@project/i18n/react";
import {useRef, useState} from "react";

import {appShellMessages} from "../../../messages/app-shell.messages";

import {sidebarExtensionsById} from "./extension-sidebar-registry";
import {ExtensionSwitcher} from "./extension-switcher";

const LONG_PRESS_MS = 450;

export function MobileExtensionButton() {
  const {t} = useI18n();
  const activeExtension = useExtensionStore((s) => s.activeExtension);
  const toggleSidebar = useExtensionStore((s) => s.toggleSidebar);
  const [isSwitcherOpen, setSwitcherOpen] = useState(false);
  const longPressTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const longPressFired = useRef(false);
  const extension = sidebarExtensionsById[activeExtension];

  function clearLongPressTimer() {
    if (longPressTimer.current) clearTimeout(longPressTimer.current);
    longPressTimer.current = null;
  }

  function startLongPress() {
    longPressFired.current = false;
    clearLongPressTimer();
    longPressTimer.current = setTimeout(() => {
      longPressFired.current = true;
      setSwitcherOpen(true);
    }, LONG_PRESS_MS);
  }

  function handlePress() {
    if (longPressFired.current) {
      longPressFired.current = false;

      return;
    }

    toggleSidebar();
  }

  return (
    <>
      <Tooltip delay={300}>
        <Button
          isIconOnly
          aria-label={t(appShellMessages.toggleExtensions)}
          variant="ghost"
          onPointerCancel={clearLongPressTimer}
          onPointerDown={startLongPress}
          onPointerLeave={clearLongPressTimer}
          onPointerUp={clearLongPressTimer}
          onPress={handlePress}
        >
          <Avatar className="size-6" color="accent" variant="soft">
            <Avatar.Fallback>{extension?.icon}</Avatar.Fallback>
          </Avatar>
        </Button>
        <Tooltip.Content placement="bottom">
          <p>{t(appShellMessages.tapExtensionsHoldToSwitch)}</p>
        </Tooltip.Content>
      </Tooltip>

      <ExtensionSwitcher isOpen={isSwitcherOpen} onOpenChange={setSwitcherOpen} />
    </>
  );
}
